<div *ngIf="loading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div>
  <ng-template #addUserModalTemplate>
    <div class="flex flex-col p-4">
      <div *ngIf="!editId" class="!pb-5 text-xl">{{ "users_page.create" | translate }}</div>
      <div *ngIf="editId" class="!pb-5 text-xl">{{ "users_page.edit" | translate }}</div>
      <app-user-form [userId]="editId" (closeForm)="closeCreateModal()"></app-user-form>
    </div>
  </ng-template>

  <div class="relative">
    <div class="panel border-[#e0e6ed] px-5 pb-1.5 dark:border-[#1b2e4b]">
      <div class="datatable invoice-table">
        <div class="mb-4.5 flex flex-col gap-5 md:flex-row md:items-center">
          <app-search-input (searchChanged)="setSearchText($event)"></app-search-input>
          <div class="ltr:ml-auto rtl:mr-auto"></div>

          <a class="btn btn-primary cursor-pointer gap-2" (click)="addTask()"> <icon-plus /> {{ "users_page.create" | translate }} </a>

          <div hlMenu class="dropdown">
            <button hlMenuButton type="button" class="flex items-center rounded-md border border-[#e0e6ed] px-4 py-2 text-sm font-semibold dark:border-[#253b5c] dark:bg-[#1b2e4b] dark:text-white-dark">
              <span class="ltr:mr-1 rtl:ml-1">{{ "table_columns" | translate }}</span>
              <icon-caret-down class="h-5 w-5" />
            </button>
            <ul *hlMenuItems @toggleAnimation class="w-max ltr:left-0 rtl:right-0">
              <ng-container *ngFor="let col of cols; index as i">
                <li>
                  <div class="flex items-center px-4 py-1">
                    <label [for]="'chk-' + i" class="mb-0 cursor-pointer">
                      <input type="checkbox" [id]="'chk-' + i" class="form-checkbox" [ngModel]="!col.hide" (ngModelChange)="col.hide = $event" (change)="updateColumn(col)" />
                      <span class="ltr:ml-2 rtl:mr-2">{{ col.title }}</span>
                    </label>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>

        <ng-datatable
          #datatable
          [rows]="items"
          [columns]="cols"
          [sortable]="true"
          [loading]="loading"
          [isServerMode]="true"
          [page]="pageNumber"
          [search]="search"
          [pageSize]="pageSize"
          [totalRows]="totalRows"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (changeServer)="changeServer($event)"
          skin="whitespace-nowrap bh-table-hover"
          [paginationInfo]="'paginationInfoLabel' | translate"
        >
          <ng-template slot="name" let-value="data">
            <div class="flex items-center font-semibold">{{ value.name }} {{ value.surname }}</div>
          </ng-template>
          <ng-template slot="email" let-value="data">
            <div class="flex items-center font-semibold">{{ value.email }}</div>
          </ng-template>
          <ng-template slot="role" let-value="data">
            <div class="flex items-center font-semibold">{{ value.role }}</div>
          </ng-template>
          <ng-template slot="createdAt" let-value="data">
            <div class="flex items-center font-semibold">{{ value.createdAt | date: "dd.MM.yyyy" }}</div>
          </ng-template>
          <ng-template slot="actions" let-value="data">
            <div class="flex w-max items-center justify-between">
              <div hlMenu class="dropdown">
                <a hlMenuButton href="javascript:;">
                  <icon-horizontal-dots class="rotate-90 opacity-70" />
                </a>
                <div #dropdownPlaceholder *hlMenuItems>
                  <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                    <li>
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="addTask(value.id)">
                        <icon-pencil-paper class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "edit_quick_label" | translate }}
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openDeleteModal(value.id)">
                        <icon-trash-lines class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "delete_quick_label" | translate }}
                      </a>
                    </li>
                  </app-message-portal>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-datatable>
      </div>
    </div>
  </div>
</div>

<div class="mt-5">
  <app-contract-users-table></app-contract-users-table>
</div>
